import Vue from 'vue'
import VueRouter, {Route} from 'vue-router'
import Login from '../views/Auth/Login.vue'
import Registration from '../views/Auth/Registration.vue'
import store from "../store/index"
import {RawLocation} from "vue-router/types/router";

Vue.use(VueRouter);

const routes = [
    {
        path: '*',
        redirect: '/login'
    },
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/sign-up',
        name: 'Registration',
        component: Registration
    },
    {
        path: '/app',
        name: 'Home',
        component: () => import("../views/Dashboard.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import("../views/App/Profile.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/accounts',
        name: 'Accounts',
        component: () => import("../views/App/Accounts.vue"),
        meta: {
            requiresAuth: true
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to: Route, from: Route, next: any) => {

    const currentUser = store.state.user as unknown as { [k: string]: any };
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) {
        next('/login');
    } else if (!requiresAuth && currentUser) {
        next('/app');
    } else if (currentUser && currentUser.verified !== true && to.fullPath !== '/profile') {
        next('/profile');
    } else {
        next();
    }
});


export default router
